import React from "react";
import { ReviewCard } from "@obby/components";
import { styles } from "./ClassReviews.styles";

export default function ClassReviews(props) {
  const { reviews = [] } = props;
  return (
    <div className={`class-reviews ${styles.classReview}`}>
      <h2 className={`class-reviews__heading ${styles.heading}`}>Reviews</h2>
      <div className={`class-reviews__list ${styles.list}`}>
        {reviews.map((review, index) => (
          <div key={index} className="class-reviews__list-item">
            <ReviewCard {...review} />
          </div>
        ))}
      </div>
    </div>
  );
}
